var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('datepicker',{attrs:{"input-class":"inp","value":_vm.value},on:{"input":function (e) { return _vm.$emit('input', e); }}})}
var staticRenderFns = []

export { render, staticRenderFns }